//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import {
  item_radio,
  item_checkbox,
  item_blank,
  item_image_single,
  item_image_multiple,
  item_dropdown_single,
  item_dropdown_multiple,
  item_select_multiple,
  item_blank_multiple,
  item_scale,
  item_sort,
  item_file,
  item_section,
  item_address,
  item_date,
  item_matrix_scale,
  item_proportion,
  questionnaireSummary,
  item_autograph
} from './modules'
import { setQuestionLogicBlock } from '@/tools/index.js'
export default {
  data() {
    return {
      index: 0,
      resetComponent: true,
      lastIndex: 0
    }
  },
  props: {
    readonly: {
      type: Boolean
    }
  },
  components: {
    item_radio,
    item_checkbox,
    item_blank,
    item_image_single,
    item_image_multiple,
    item_dropdown_single,
    item_dropdown_multiple,
    item_select_multiple,
    item_blank_multiple,
    item_scale,
    item_sort,
    item_file,
    item_section,
    item_address,
    item_date,
    item_matrix_scale,
    questionnaireSummary,
    item_proportion,
    item_autograph
  },
  computed: {
    ...mapGetters(['questionnaireList', 'questionnaireReturnData']),
    question() {
      return this.questionnaireList[this.index]
    },
    indexList() {
      let temp = 0
      return this.questionnaireList.map((item) => {
        if (item.v_visible && item.displayIndex) {
          temp += 1
          return {
            index: temp
          }
        } else {
          return {
            index: ''
          }
        }
      })
    },
    visibleQuestionList() {
      return this.questionnaireList.filter((item) => {
        return item.v_visible && item.type !== 'section'
      })
    }
  },
  watch: {
    'visibleQuestionList.length': {
      handler() {
        for (var i = this.questionnaireList.length - 1; i >= 0; i--) {
          if (this.questionnaireList[i].v_visible) {
            this.lastIndex = i
            console.log(this.index);
            console.log(this.lastIndex);
            // 不是第一题且不是最后一题
            if (this.index < this.lastIndex && this.index > 0) {
              this.$emit('middleOne')
            } else if (this.index == this.lastIndex) {
              this.$emit('lastOne')
            }
            break
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    async onNextClicked() {
      var check = await this.validateAnswer()
      if (!check) {
        new this.$Toast({
          text: '请先完善"必填项"',
          time: 1500,
          position: 'top',
          distance: '50%',
        });
        if (this.index == 0) {
          this.$emit('firstOne')
        }
        return
      }
      this.index++
      // 如果该题不可见则index+1跳到下个题
      if (!this.question.v_visible) {
        this.index++
      }
      // 如果超过数组长度
      if (this.index >= this.lastIndex) {
        this.$emit('lastOne')
        this.reset()
        return
      }
      // 查询下一条是否显示，不显示继续向下找
      if (!this.question.v_visible) {
        this.onNextClicked()
      } else {
        this.reset()
      }
    },
    onPrevClicked() {
      this.index--
      // 如果该题不可见则index-1跳到上个题
      if (!this.question.v_visible) {
        this.index--
      }
      // 如果到第一题
      if (this.index == 0) {
        this.$emit('firstOne')
        this.reset()
        return
      }
      // 查询上一条是否显示，不显示继续向上找
      if (!this.question.v_visible) {
        this.onPrevClicked()
      } else {
        this.reset()
      }
    },
    reset() {
      // 重置组件， 初始化各组件值
      this.resetComponent = false
      this.$nextTick(() => {
        this.resetComponent = true
      })
    },
    // 选择题选中
    onSelectChange(isCancel = false) {
      console.log(111, this.questionnaireList, isCancel);
      setQuestionLogicBlock(this.questionnaireList, isCancel)
    },
    async validateAnswer() {
      if (this.question.v_visible) {
        const validate = await this.$refs[`item${this.question.tenantId}`].validate()
        console.log(validate);
        return validate
      } else {
        return true
      }
    }
  }
}
